export function hasAttachments(files) {
  return Boolean(files?.data.pages[0]?.attachments?.length)
}

/**
 * Determines if user can navigate to the app settings page for a plugin.
 * Returns false for legacy integrations (like Mighty Networks) that don't
 * have a proper reinstall flow.
 */
export function canNavigateToApp(plugin) {
  const app = plugin?.provider?.app
  return Boolean(app?.id && !app?.skip_reinstall_link)
}
